'use strict';

var waterfall = require('async/waterfall');

var log = require('debug')('ipfs:mfs:mkdir');

var _require = require('./utils'),
    updateMfsRoot = _require.updateMfsRoot,
    updateTree = _require.updateTree,
    traverseTo = _require.traverseTo,
    FILE_SEPARATOR = _require.FILE_SEPARATOR;

var defaultOptions = {
  parents: false,
  hash: undefined,
  cidVersion: 0
};

module.exports = function (ipfs) {
  return function mfsMkdir(path, options, callback) {
    if (typeof options === 'function') {
      callback = options;
      options = {};
    }

    options = Object.assign({}, defaultOptions, options);
    options.parents = options.p || options.parents;
    options.cidVersion = options.cidVersion || 0;

    if (!path) {
      return callback(new Error('no path given to Mkdir'));
    }

    path = path.trim();

    if (path === FILE_SEPARATOR) {
      return callback(options.parents ? null : new Error("cannot create directory '".concat(FILE_SEPARATOR, "': Already exists")));
    }

    log("Creating ".concat(path));
    waterfall([function (cb) {
      traverseTo(ipfs, path, {
        parents: false,
        createLastComponent: false
      }, function (error) {
        if (!error) {
          log("".concat(path, " already exists"));
          return cb(new Error('file already exists'));
        }

        if (error.message.includes('does not exist')) {
          log("".concat(path, " does not exist"));
          return cb();
        }

        return cb(error);
      });
    }, function (cb) {
      return traverseTo(ipfs, path, {
        parents: options.parents,
        flush: options.flush,
        createLastComponent: true
      }, cb);
    }, function (result, cb) {
      return updateTree(ipfs, result, cb);
    }, function (newRoot, next) {
      return updateMfsRoot(ipfs, newRoot.node.multihash, next);
    }], function (error) {
      if (error && error.message.includes('file already exists') && options.parents) {
        // when the directory already exists and we are creating intermediate
        // directories, do not error out (consistent with mkdir -p)
        error = null;
      }

      callback(error);
    });
  };
};